import React, { useState } from "react";
import RadioButton from "../../../../../components/form/radio/RadioButton";
import ListViewSearch from "../../../../../components/commonComponents/ListViewHeader/ListViewSearch";

export const Province = ({
  stateList,
  selectedLocation,
  handleLocationClick,
  locationType,
}) => {
  const [searchKey1, setSearchKey1] = useState("");

  const handleSearch1 = (value) => {
    setSearchKey1(value);
  };
  const filteredStateList = stateList.filter((data) =>
    data.name.toLowerCase().includes(searchKey1.toLowerCase())
  );
  return (
    <div className="country-popover flex-column w-100 p-10">
      <ListViewSearch searchingText={(text) => handleSearch1(text)} />

      {filteredStateList?.map((data) => {
        return (
          <div
            className="flex-column pointer p-10 max-h-[10vh]"
            key={data?.id}
            onClick={() => {
              handleLocationClick("state", data?.name, data?.id, locationType);
            }}
          >
            <div className="flex-row align-center justify-between">
              <span className="">{data?.name}</span>
              {selectedLocation?.state?.id === data?.id && (
                <RadioButton selected={true} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
